<template>
    <div class="mt-2">
        <div v-if="movies.length" class="flex flex-col gap-2">
            <div
                v-for="movie in movies.slice(0, count)"
                :key="movie.id"
                class="home-movie-row flex items-start gap-3 overflow-hidden rounded border border-slate-700/40 bg-slate-900/30 p-2"
                itemscope
                itemtype="http://schema.org/Movie"
            >
                <div class="min-w-0 flex-1">
                    <div class="flex items-start justify-between gap-2">
                        <h3
                            class="text-sm font-semibold leading-tight text-slate-100"
                            itemprop="name"
                        >
                            {{ movie.title }}
                        </h3>
                        <span class="shrink-0 text-xs text-slate-400">{{
                            movie.year
                        }}</span>
                    </div>
                    <div class="mt-0.5 flex items-center gap-2">
                        <span
                            class="text-xs text-slate-300"
                            itemprop="datePublished"
                        >
                            {{ formatDate(movie.release_date, 'MMM D, YYYY') }}
                        </span>
                        <span
                            class="rounded-full px-1.5 py-px text-xs uppercase tracking-wide"
                            :class="
                                movie.status === 'released'
                                    ? 'text-slate-400'
                                    : 'text-green-400'
                            "
                        >
                            {{ convertStatus(movie.status) }}
                        </span>
                    </div>
                    <p
                        v-if="movie.genres"
                        class="mt-0.5 truncate text-xs text-slate-400"
                    >
                        {{ movie.genres }}
                    </p>
                </div>
            </div>
        </div>
        <div
            v-else
            class="flex h-24 w-full flex-wrap items-center justify-center text-center text-slate-400"
        >
            No Upcoming Movies. Check Back Soon!
        </div>
    </div>
</template>

<script>
import { convertStatus, formatDate } from '@/utils/Utilities';
import { gsap } from 'gsap/all';

export default {
    name: 'HomeUpcomingMovies',
    props: {
        movies: {
            type: Array,
            default: () => [],
        },
        count: {
            type: Number,
            default: 5,
        },
    },
    mounted() {
        gsap.fromTo(
            '.home-movie-row',
            { y: 10, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.03, duration: 0.25 },
        );
    },
    methods: {
        convertStatus,
        formatDate,
    },
};
</script>

<style lang="postcss">
.home-movie-row {
    opacity: 0;
}
</style>
